import React from 'react';
import RetroActiveInput from './RetroActiveInput';

import type { PrimeXQuoteHandlers, PrimeXQuoteState } from '../types';
import { GlobalFieldNames } from '../types';
import { deriveRetroUpdatePath, isValidDateString } from '../utils';

const GlobalRetroActiveInput = (props: GlobalRetroActiveInputProps) => {
  const setValue = (value: string | number) => {
    props.setGlobalValue({
      [GlobalFieldNames.retroactive]: deriveRetroUpdatePath(value),
    });
  };

  let _value = props.retroValueProps?.props?.period?.value ?? '';
  if (!_value) {
    _value = props.retroValueProps?.props?.date?.value ?? '';
  }

  // A committed custom date has to appear among the options so it can be
  // rendered as the selected value. Build a new array — pushing onto
  // `props.options` mutates the rules object shared with the rest of the quote.
  const isUnlistedCustomDate =
    isValidDateString(_value) && !props.options.includes(_value);
  const _options = isUnlistedCustomDate
    ? [...props.options, _value]
    : props.options;

  return (
    <RetroActiveInput
      setValue={setValue}
      options={_options}
      value={_value}
      maxDate={props.maxDate}
      defaultDate={props.defaultDate}
    />
  );
};

export default GlobalRetroActiveInput;

type GlobalRetroActiveInputProps = {
  setGlobalValue: PrimeXQuoteHandlers['setGlobalValue'];
  options: Array<string | number>;

  maxDate: string;
  defaultDate: string;
  retroValueProps: PrimeXQuoteState['global']['value']['props']['retroactive'];
};
